import React, { useContext, useEffect, useState } from 'react';
import {
  ThemeProvider,
  CssBaseline,
  Box,
  Typography,
  Button,
  LinearProgress,
  Dialog
} from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import themev5 from '../../themev5';
import DatagridFooter from '../Datagrid/DatagridFooter';
import DatagridNoRowsOverlay from '../Datagrid/DatagridNoRowsOverlay';

import Styles from './styles/ProductResourcesCuration.styles';
import styles from '../Datagrid/Datagrid.styles';

import { RRTableRow } from './types';
import Store from '../../store';
import Actions from '../../store/actions';
import { getUncuratedPMDAReviewReports } from '../../api/pmda';
import ReviewReportDialog from './ReviewReportDialog';

const ReviewReportResourceCuration = () => {
  const classes = Styles();
  const [dataTableRows, setDataTableRows] = useState<Array<RRTableRow>>([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(0);
  const { dispatch } = useContext<any>(Store);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [rowData, setRowData] = useState<RRTableRow>();
  const [reload, setReload] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const result = await getUncuratedPMDAReviewReports(pageSize, pageNo);

        setIsLoading(false);
        if (!result?.data?.body?.result) {
          dispatch({
            type: Actions.SET_ALERT,
            value: { status: true, message: 'Error: Review Report resources not available' }
          });
        }

        setDataTableRows(result.data.body.result);
        setTotalRowCount(result.data.body.total);
      } catch (error) {
        await dispatch({
          type: Actions.SET_ALERT,
          value: { status: true, message: (error as Error).message }
        });
      }
    };

    getData();
  }, [pageNo, pageSize, reload]);

  const openEditDialog = (data: RRTableRow) => {
    setRowData(data);
    setShowEditDialog(true);
  };

  const closeEditDialog = () => {
    setShowEditDialog(false);
    setReload(prevState => !prevState);
  };

  const DATAGRID_COLUMNS: GridColDef[] = [
    {
      field: 'Edit',
      width: 100,
      headerAlign: 'center',
      headerName: 'Edit',
      align: 'center',
      renderCell: (params: GridRenderCellParams<RRTableRow>) => {
        return (
          <Button
            variant='contained'
            className={classes.Button}
            onClick={() => {
              openEditDialog(params.row);
            }}>
            <Typography>Edit</Typography>
          </Button>
        );
      }
    },
    {
      field: 'resource_id',
      headerName: 'Resource ID',
      width: 250,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'name',
      headerName: 'Resource Name',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'report_type',
      headerName: 'Report Type',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    }
  ];

  return (
    <ThemeProvider theme={themev5}>
      <CssBaseline />
      <Box
        height='80vh'
        mt={10}
        p={2}
        display='flex'
        alignItems='center'
        justifyContent='center'
        className={classes.root}>
        <DataGrid
          sx={styles.datagrid}
          style={{ height: '100%' }}
          rowSpacingType='margin'
          sortingOrder={['desc', 'asc']}
          checkboxSelection={false}
          density='standard'
          rows={dataTableRows}
          rowCount={totalRowCount}
          columns={DATAGRID_COLUMNS}
          loading={isLoading}
          getRowId={row => row.resource_id}
          paginationMode='server'
          getRowClassName={() => `table-rows`}
          pageSize={pageSize}
          page={pageNo}
          onPageSizeChange={newPageSize => {
            setPageSize(newPageSize);
            setPageNo(0);
          }}
          onPageChange={setPageNo}
          // rowsPerPageOptions={rowsPerPageOptions}
          components={{
            LoadingOverlay: LinearProgress,
            Footer: DatagridFooter,
            NoRowsOverlay: DatagridNoRowsOverlay
          }}
          pagination
        />

        <Dialog
          open={showEditDialog}
          onClose={closeEditDialog}
          sx={{ backdropFilter: 'blur(5px)' }}
          maxWidth='lg'>
          <ReviewReportDialog closeEdit={closeEditDialog} resourceId={rowData?.resource_id} />
        </Dialog>
      </Box>
    </ThemeProvider>
  );
};

export default React.memo(ReviewReportResourceCuration);
